import React from 'react';
import PropTypes from 'prop-types';

import {Typography} from 'views/components';
import {translate} from 'views/module';

const JobTitle = (props) => {
  const {location, requirements, jobDataParsed} = props;
  const locationTitle = translate('jobDetail.JobLocation',
      {
        neighborhood: location.neighborhood,
        city: location.city,
      },
  );
  // Account for missing certifications in the translation
  const certifications = requirements.certifications
      .map((cert) => translate(`jobDetail.Requirements.CertificationsOptionsShort.${cert}`))
      .filter((translation) => translation && translation !== 'Missing translation');

  // Put it all together to display
  const title = [locationTitle, certifications.join(' / '), jobDataParsed.payPerWeekString]
      .filter(Boolean)
      .join(' • ');

  return (
    <Typography variant="h5" sx={{fontWeight: 800, letterSpacing: -0.2}}>
      {title}
    </Typography>
  );
};

JobTitle.propTypes = {
  location: PropTypes.object.isRequired,
  requirements: PropTypes.object.isRequired,
  jobDataParsed: PropTypes.object.isRequired,
};

export default JobTitle;
